module.exports = __webpack_public_path__ + "img/family.cee6af34.svg";